<script setup>
import { computed } from 'vue'
import {
  Sparkles,
  Grid2X2,
  Play,
  Pause,
  ChevronLeft,
  Plus,
  Minus,
  Search,
  ChevronsLeft,
  ChevronsRight,
  PanelLeftClose,
  PanelLeftOpen,
  Scan,
  Download,
  Upload,
  X,
  ChevronDown,
  ChevronRight,
  Check,
  ArrowUpRight,
  Maximize2,
  Minimize2,
  RotateCcw,
  FileText,
  Network,
  SlidersHorizontal,
  Pencil,
  Trash2,
  ArrowRight,
  Link,
  Filter,
  LoaderCircle,
} from 'lucide-vue-next'
const props = defineProps({ name: String, size: { type: Number, default: 16 } })
const icons = {
  Sparkles,
  Grid2X2,
  Play,
  Pause,
  ChevronLeft,
  Plus,
  Minus,
  Search,
  ChevronsLeft,
  ChevronsRight,
  PanelLeftClose,
  PanelLeftOpen,
  Scan,
  Download,
  Upload,
  X,
  ChevronDown,
  ChevronRight,
  Check,
  ArrowUpRight,
  Maximize2,
  Minimize2,
  RotateCcw,
  FileText,
  Network,
  SlidersHorizontal,
  Pencil,
  Trash2,
  ArrowRight,
  Link,
  Filter,
  LoaderCircle,
}
const icon = computed(() => icons[props.name] || Plus)
</script>
<template><component :is="icon" :size="size" :stroke-width="1.6" aria-hidden="true" /></template>
